import React, { useState } from "react";
import { HiMenuAlt3 } from "react-icons/hi";

const Nav = () => {
  const [navbarOpen, setNavbarOpen] = useState(false);

  return (
    <>
      <nav className="flex flex-wrap items-center justify-between px-2 py-1 sticky inset-x-0 top-0 z-50 bg-white ">
        <div className="container mx-auto flex flex-wrap items-center justify-between px-5">
          <div className="w-full relative flex justify-between lg:w-auto lg:static lg:block lg:justify-start">
            <a
              className="text-sm font-bold leading-relaxed inline-block mr-4 py-2 whitespace-nowrap uppercase text-black"
              href="/#home"
            >
              <img className="h-16" src="images/logo.png" alt="logo" />
            </a>
            <div className="flex gap-x-2 items-center">
              <button
                className="cursor-pointer text-xl leading-none px-3 py-1 border border-solid border-transparent rounded bg-transparent block lg:hidden outline-none focus:outline-none"
                type="button"
                onClick={() => setNavbarOpen(!navbarOpen)}
              >
                <HiMenuAlt3 />
              </button>
            </div>
          </div>
          <div
            className={
              "lg:flex flex-grow items-center" +
              (navbarOpen ? " flex" : " hidden")
            }
          >
            <div className="flex flex-col lg:flex-row list-none lg:ml-auto">
              <a className="navitem" href="/">
                Home
              </a>

              <a className="navitem" href="/">
                About
              </a>
              <a className="navitem" href="/">
                Services
              </a>
              <a className="navitem" href="/">
                Our Team
              </a>
              <a className="navitem" href="/">
                Clinets
              </a>
              <a className="navitem" href="/">
                Contact
              </a>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Nav;
